import { Injectable } from '@angular/core';
import { FilterSolicitudes, SolicitudesSearch } from '../model/solicitudes';
import { Page } from '../model/page';
import { FormGroup, FormControl } from '@angular/forms';
import { Proveedor } from '../model/proveedor';

@Injectable({
  providedIn: 'root'
})
export class FiltrosConsultaSolicitudesService {
  public filterSolicitudes: FilterSolicitudes[];
  public filterSolicitudesSelected: FilterSolicitudes[];
  public filterSolicitudesSelectedIds: number[];
  public solicitudesSearch: SolicitudesSearch;
  public idUsuario = undefined;
  public idGrupo = undefined;
  public idProveedor = undefined;
  public clientSelected: string | number[] = '-1';
  public page: Page;
  public filterForm: FormGroup;

  constructor() {
    this.resetFilters();
  }

  resetFilters() {
    this.filterSolicitudes = [];
    this.filterSolicitudesSelected = [];
    this.filterSolicitudesSelectedIds = [];
    this.solicitudesSearch = new SolicitudesSearch();
    this.idUsuario = undefined;
    this.idGrupo = undefined;
    this.idProveedor =  undefined;
    this.clientSelected = '-1';
    this.page = new Page();
    this.page.size = 10;
    this.page.pageNumber = 0;
    this.filterForm = new FormGroup({
      cliente: new FormControl('-1'),
      //🥑
      serieDocumental: new FormControl('-1'),
      grupo: new FormControl(this.idGrupo),
      usuario: new FormControl(this.idUsuario),
      id: new FormControl(''),
      servicio: new FormControl('-1'),
      estado: new FormControl('-1'),
      prioridad: new FormControl('-1'),
      altadesde: new FormControl(''),
      altahasta: new FormControl(''),
      pdteaprobacion: new FormControl('-1'),
      pdteaprobacionporuser: new FormControl('-1'),
      situacion: new FormControl('-1'),
      fechaFinalizacion: new FormControl(undefined),
      fFinalizacionComparator: new FormControl(1),
      estadisticas: new FormControl('-1'),
      departamento: new FormControl('-1'),
      proveedor: new FormControl(this.idProveedor)

    });
   }
}
